export const formatterDecimal = new Intl.NumberFormat('nl-NL', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
});

export const formatterInteger = new Intl.NumberFormat('nl-NL', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export const formatterCurrency = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})

export const formatterPercentage = new Intl.NumberFormat('nl-NL', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
});